import type { ComponentType } from 'react';
import { MoreHorizontal } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { ICON_BUTTON_CLASS } from '@/lib/styles';

export interface RowAction {
  label: string;
  icon: ComponentType<{ className?: string }>;
  onSelect: () => void;
  disabled?: boolean;
}

/** The "⋯" button at the end of a table row and its list of actions. */
export function RowActionsMenu({ label, actions }: { label: string; actions: RowAction[] }) {
  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon" className={ICON_BUTTON_CLASS} aria-label={label}>
          <MoreHorizontal className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-[190px] rounded-lg p-1.5">
        {actions.map(({ label: itemLabel, icon: Icon, onSelect, disabled }) => (
          <DropdownMenuItem
            key={itemLabel}
            disabled={disabled}
            onSelect={onSelect}
            className="h-9 cursor-pointer gap-2.5 px-2.5 text-sm text-gray-800 focus:bg-[#4369a0]/5 focus:text-[#4369a0]"
          >
            <Icon className="h-3.5 w-3.5 text-gray-500" />
            {itemLabel}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
